import React from "react";
import Layout from "src/components/layout/website/Layout";

const PrivacyPage: React.FC = () => {
  return (
    <Layout>
      <div className="min-h-screen bg-white py-16 px-6 max-w-5xl mx-auto">
        <h1 className="text-3xl font-bold text-indigo-600 mb-6">
          Privacy Policy
        </h1>
        <p className="text-gray-600 mb-6">
          Invyntra values your privacy. This policy explains how we collect,
          use, and protect your personal data.
        </p>
        <ul className="list-disc ml-6 text-gray-600 space-y-2">
          <li>
            We collect only essential data for account setup and usage
            analytics.
          </li>
          <li>
            Your data is never sold or shared with third-party advertisers.
          </li>
          <li>All data transmissions are encrypted and securely stored.</li>
          <li>
            You can request data deletion anytime by writing to
            support@invyntra.com.
          </li>
        </ul>
        <p className="text-gray-600 mt-6">
          We may update this policy periodically. Continued use implies
          acceptance of these updates.
        </p>
      </div>
    </Layout>
  );
};

export default PrivacyPage;
